@if (data()) {
  @let execution = data()!;

  @let detailOpen = panelView() === 'detail';

  <!--
    Mobile briefing sheet: the tile column sits above the details in one page scroll, and the deliverable view hides
    the tile column. Panel styles for this live in cta-analytics-table.component.scss.
  -->
  <div class="flex w-full h-full" [ngClass]="{ 'max-md:flex-col max-md:h-auto': creatorBriefingMode() }">
    <div
      class="flex flex-col gap-3 w-[272px] shrink-0 overflow-y-auto pr-1 -mr-6 [scrollbar-gutter:stable]"
      [ngClass]="{
        'max-md:w-full max-md:overflow-visible max-md:pr-0 max-md:mr-0': creatorBriefingMode(),
        'max-md:hidden': creatorBriefingMode() && detailOpen,
      }"
    >
      <div class="flex items-center justify-center self-stretch">
        <app-social-content-tile
          class="w-[248px] self-stretch"
          [ngClass]="{ 'max-md:w-full': creatorBriefingMode() }"
          [tileConfiguration]="execution.tileConfiguration"
          [clickable]="false"
          [creatorBriefingMode]="creatorBriefingMode()"
          [exportMode]="exportMode()"
          [campaignExport]="campaignExport()"
          [dialogMode]="true"
          (click)="$event.stopPropagation()"
        />
      </div>

      <app-cta-analytics-details-kpis-tile
        class="self-stretch"
        [ngClass]="{
          'max-md:hidden':
            creatorBriefingMode() && !execution.isLive && !execution.url && !kpiCardDataForKpisTile().length,
        }"
        [creatorBriefingMode]="creatorBriefingMode()"
        [execution]="execution"
        [kpiCardData]="kpiCardDataForKpisTile()"
        [platformFeature]="execution.platformFeature"
      />

      @if (!exportMode()) {
        @if (socialContentIdForFiles(); as socialContentId) {
          <app-social-content-files
            class="self-stretch"
            [briefingId]="briefingId()"
            [campaignId]="execution.campaignId"
            [creatorBriefingMode]="creatorBriefingMode()"
            [socialContentId]="socialContentId"
          />
        }
      }
    </div>

    <div
      class="shrink-0 w-px self-stretch ml-6 bg-shikenso-purple-base-12"
      [ngClass]="{
        'max-md:w-auto max-md:h-px max-md:ml-0 max-md:my-6': creatorBriefingMode(),
        'max-md:hidden': creatorBriefingMode() && detailOpen,
      }"
    ></div>

    <div
      class="cta-analytics-right-panel"
      [class.cta-analytics-right-panel--sheet]="creatorBriefingMode()"
      [class.cta-analytics-right-panel--detail]="panelView() === 'detail'"
      [class.cta-analytics-right-panel--back]="panelView() === 'overview' && navigationDirection() === 'back'"
    >
      <div #overviewPanel class="cta-analytics-panel cta-analytics-panel--overview">
        <app-cta-analytics-details
          class="pr-2"
          [adminMode]="adminMode()"
          [analyticsNode]="analyticsNode()"
          [campaignExport]="campaignExport()"
          [creatorBriefingMode]="creatorBriefingMode()"
          [creatorId]="creator().id"
          [ctaResult]="ctaResult()"
          [deliverableCardData]="deliverableCardData()"
          [execution]="execution"
          [exportMode]="exportMode()"
          [kpiGoalsKpiCards]="kpiGoalsKpiCards()"
          [platformFeature]="execution.platformFeature"
          (ctaExecutionChange)="ctaExecutionChange.emit($event)"
          (deliverableSelected)="deliverableSelected.emit($event)"
        />
      </div>

      <div #detailPanel class="cta-analytics-panel cta-analytics-panel--detail">
        @if (detailPanelContext(); as detailContext) {
          <div class="flex min-h-full flex-col gap-2">
            <button
              mat-flat-button
              type="button"
              color="transparent"
              class="ml-6 mat-tiny-button w-fit !pl-0"
              [ngClass]="{ 'max-md:!hidden': creatorBriefingMode() }"
              (click)="onBackToOverview()"
            >
              <div class="flex items-center gap-2">
                <app-icon src="icons/arrow-left.svg" [size]="16" />
                <span class="text-xs text-shikenso-purple-base-60">
                  {{ 'pages.campaignDetails.ctaAnalytics.details.backToOverview' | translate }}
                </span>
              </div>
            </button>

            <app-deliverable-analytics-content
              class="flex min-h-0 flex-1 flex-col"
              [deliverableForm]="detailContext.deliverableForm"
              [deliverableId]="detailContext.deliverableId"
              [deliverableType]="detailContext.deliverableType"
              [executionAnalytics]="detailContext.executionAnalytics"
              [platformFeature]="execution.platformFeature"
              [deliverableCardData]="detailContext.deliverableCardData"
              [creatorBriefingMode]="creatorBriefingMode()"
              [exportMode]="exportMode()"
              [campaignExport]="campaignExport()"
              [adminMode]="adminMode()"
            />
          </div>
        }
      </div>
    </div>
  </div>
}
